import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Row } from "react-bootstrap";
// import { CheckboxTree } from "@idui/react-tree";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';
import { BsCheck2Square, BsDashSquare, BsFileEarmark } from "react-icons/bs";
import { BiChevronDown, BiChevronRight, BiFolder, BiFolderOpen, BiSquare } from "react-icons/bi";
import { VscCollapseAll, VscExpandAll } from "react-icons/vsc";
import { Grid } from "@mui/material";
import { IoMdArrowBack } from "react-icons/io";


export const CreateRole = () => {

    const navigate = useNavigate();
    const { id } = useParams()
    let [loading, setLoading] = useState(false);
    const [nodes, setNodes] = useState([]);
    const [checked, setChecked] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);


    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center">
                        <Link to='/roles' className='back_btn_wrap'>
                            <IoMdArrowBack className='icon' />
                        </Link>
                        <h4 className="mb-sm-0">{id ? 'Edit' : 'Create'} Role</h4>
                    </div>
                </div>
            </div>
            <div className="pe-2">
                <Form >

                    <div className="mb-3">
                        <div className="create-form-card">
                            <Row>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Role</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter role name"
                                            name='name'
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div style={{ maxWidth: '350px' }}>
                                        <CheckboxTree
                                            nodes={nodes}
                                            checked={checked}
                                            expanded={expanded}
                                            onExpand={expanded => setExpanded(expanded)}
                                            icons={{
                                                check: <BsCheck2Square />,
                                                uncheck: <BiSquare />,
                                                halfCheck: <BsDashSquare />,
                                                expandClose: <BiChevronRight />,
                                                expandOpen: <BiChevronDown />,
                                                expandAll: <VscExpandAll />,
                                                collapseAll: <VscCollapseAll />,
                                                parentClose: <BiFolder />,
                                                parentOpen: <BiFolderOpen />,
                                                leaf: <BsFileEarmark />,
                                            }}
                                        />
                                    </div>
                                </div>

                            </Row>
                        </div>
                    </div>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className='create-btn-grid'>
                        <Button className='save_btn' disabled={loading}>
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    {loading ? "Loading" : id ? "Update" : "Save"}
                                </div>
                            </div>
                        </Button>
                        {/* <button class="btn btn-custom-primary btn-label" onClick={formik.handleSubmit}>
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    {loading ?
                                        <div className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ color: "white", height: '100%' }}>

                                            <CircularProgress size={20} style={{ color: "white" }} />

                                        </div>
                                        :
                                        <div className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ height: '100%' }}>
                                            {id ?
                                                <TbDatabaseEdit size={20} />
                                                :
                                                <IoIosAdd size={20} />
                                            }
                                        </div>
                                    }
                                </div>
                                <div class="flex-grow-1">
                                    {loading ? "Loading" : id ? "Update" : "Save"}
                                </div>
                            </div>
                        </button> */}
                    </Grid>

                </Form>
            </div>

        </>
    );
};
